import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_STATUS } from "../../constants";
import HeaderMenu from "../sidebar/headermenu";
import PlaceHolder from "../../utils/placeholder";
import { useDispatch, useSelector } from "react-redux";
import { reloadState } from "../../redux/GlobalSlice";
import { GetSubPlans } from "../../apis/user/get_sub_plan";
import { SaveSubPayment } from "../../apis/user/save_sub_payment";
import { GetPaymentOrderId } from "../../apis/user/get_payment_orderid";
import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
import parse from 'html-react-parser';
import { AdminMargin } from "../../apis/user/admin_margin";
import { StoragePurchase } from "../../apis/user/storage_purchase";

export default function PurchaseStorage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);


    const [planStatus, setPlanStatus] = useState(API_STATUS);
    const [ApiStatus, setApiStatus] = useState(API_STATUS);
    const [PayApi, setPayApi] = useState(API_STATUS);
    const [PlanData, setPlanData] = useState([]);
    const [selected, setSelected] = useState('2');
    const [activeItem, setActiveItem] = useState(10);
    const [approve, setApprove] = useState(false);
    const [approveErr, setApproveErr] = useState(false);
    const [selPlan, setSelPlan] = useState('');
    const [errorMsg, setError] = useState('');
    const [amount, setAmount] = useState(0);
    const [bamount, setbAmount] = useState(0);
    const [userData, setUserData] = useState('');

    const [loginId, setLoginId] = useState('');

    const { error, isLoading, Razorpay } = useRazorpay();

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);

            const loginData = sessionStorage.getItem('LOGIN_DATA');
            if (loginData !== null) {
                const udata = JSON.parse(loginData);
                setUserData(udata);
            }
        }
    }, []);

    useEffect(() => {
        GetSubPlans(setPlanStatus);
    }, []);

    useEffect(() => {
        if (approve) {
            setApproveErr(false);
        }
    }, [approve])

    useEffect(() => {
        if (!planStatus.isError && !planStatus.isLoader && planStatus.data != null) {
            const res = planStatus.data;
            if (res['status'] === 1) {
                setPlanData(res.data);
                setActiveItem(1);
                setbAmount(0);
                // setAmount(parseInt(res.data[0].amount) + parseInt(res.data[1].amount));
                // setSelPlan({ 'planId': res.data[0].id, 'amount': res.data[0].amount, 'plan': res.data[0].title });
            }
        }
    }, [planStatus]);

    const makePayment = (data) => {

        const options = RazorpayOrderOptions = {
            key: "rzp_test_BKvWBTGpzXmQhm",
            amount: data['amount'] * 100, // Amount in paise
            currency: "INR",
            name: "Filmwings",
            description: "Artist Subscription",
            // order_id: data['order_id'], // Generate order_id on server
            handler: (response) => {
                if (response['razorpay_payment_id'] !== null) {
                    submitSubscription(response);
                }
            },
            prefill: {
                name: userData['firstName'],
                email: userData['email'],
                contact: userData['mobile'],
            },
            theme: {
                color: "#F37254",
            },
        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.open();

    }

    const submitSubscription = (res) => {
        const body = selPlan;
        body['subId'] = '0';
        body['payStatus'] = '1';
        body['verify'] = bamount;
        body['detail'] = selPlan['size']+' Storage';
        body['total'] = parseInt(selPlan['amount']) + parseInt(bamount);
        body['payMethod'] = 'Razorpay';
        body['payId'] = res['razorpay_payment_id'];
        body['payRef'] = res['razorpay_order_id'];

        StoragePurchase(body, setApiStatus);
    }

    const submitData = () => {
        const body = selPlan;
        body['verify'] = bamount;
        body['total'] = parseInt(selPlan['amount']) + parseInt(bamount);
        makePayment({ 'amount': parseInt(selPlan['amount']) + parseInt(bamount), 'order_id': '' });

        // console.log(body);
        // GetPaymentOrderId(body, setPayApi);

        // SaveSubPayment(body, setApiStatus);
    }

    useEffect(() => {

        if (!PayApi.isError && !PayApi.isLoader && PayApi.data != null) {
            var res = PayApi.data;
            if (res.status === 1) {
                makePayment({ 'amount': parseInt(selPlan['amount']) + parseInt(bamount), 'order_id': res.order_id });
            }
        }
    }, [PayApi]);

    useEffect(() => {
        if (!ApiStatus.isError && !ApiStatus.isLoader && ApiStatus.data != null) {
            const res = ApiStatus.data;
            if (res['status'] === 1) {
                AdminMargin(res['data']);
                navigate('/artist_profile/' + loginId + '/true');
            }
        }
    }, [ApiStatus]);

    useEffect(() => {
        if (activeItem != 10) {
            setSelected(PlanData[activeItem].id);
            setAmount(PlanData[activeItem].amount);
            setSelPlan({
                'planId': PlanData[activeItem].id,
                'amount': PlanData[activeItem].amount,
                'plan': PlanData[activeItem].title,
                'size': PlanData[activeItem].size
            });
        }
    }, [activeItem]);

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="max-w-4xl mx-auto px-1 py-1">
                <div class="page__heading py-6 mt-6">
                    <a href={'/profile/' + loginId}>
                        <ion-icon name="chevron-back-outline"></ion-icon> Back
                    </a>
                    <h1> Purchase Space </h1>
                </div>

                <div class="max-w-3x flex-1 relative">

                    {
                        PlanData.length > 0 &&


                        <div className="flex flex-wrap gap-4">
                            {
                                PlanData.map((item, i) =>
                                    <div key={i}
                                        onClick={() => {
                                            setActiveItem(i);
                                        }}
                                        className="bg-white w-[253px] rounded-md p-4 border border-2 text-center" style={{ borderColor: activeItem == i ? '#16a34a' : '', cursor: 'pointer' }}>
                                        <div style={{ borderBottom: 'solid 1px #ddd', paddingBottom: 10 }}>
                                            <div className="text-xl font-600" style={{ color: activeItem == i ? '#16a34a' : '' }}>{item.title}</div>
                                            <div className="text-base">Our foundational package</div>
                                            <div className="text-base">One Time Pay <span className="text-green-600 font-bold text-xl">₹{item.amount}</span></div>
                                        </div>
                                        <div className="mt-2">
                                            {item.size == 'Unlimited' ? 'Unlimited' : item.size + ' MB'} Storage
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    }


                    <div className="flex mt-2">
                        {
                            planStatus.isLoader &&
                            <div role="status" style={{ justifyItems: 'center', alignContent: 'center' }}>
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        }


                    </div>

                    <div className="mt-5">
                        <h3 class="md:text-xl text-base font-semibold text-black dark:text-white">Total Amount : {amount}.00 </h3>
                    </div>
                    <div className="mt-5">
                        <div>
                            <label class="inline-flex items-center">
                                <input type="checkbox" onChange={() => {
                                    setApprove(!approve);
                                }} name="radio-s2" value="1" style={{ borderWidth: 1, borderColor: '#000' }} />
                                <span class="ml-3"> I agree to receive SMS, Whats app / Email Newsletter, Messages from Filmwings</span>
                            </label>
                        </div>
                        {
                            approveErr &&
                            <div className="text-red-400">Accept above condition</div>
                        }
                    </div>
                    {
                        PlanData !== null && PlanData.length > 0 &&

                        <div className="flex items-center justify-center gap-4 mt-10 mb-10">
                            <button
                                onClick={() => {
                                    if (!approve) {
                                        setApproveErr(true);
                                    } else {
                                        submitData();
                                    }
                                }}
                                type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Confirm <span className="ripple-overlay"></span></button>
                        </div>
                    }
                    {
                        ApiStatus.isLoader &&
                        <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                            <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                    }
                </div>
            </div>
        </main>
    </div>
}